module.exports = __webpack_public_path__ + "static/media/galerija_2021 (16).601765e9.jpg";